import { render, staticRenderFns } from "./ChatGroupReaded.vue?vue&type=template&id=4fdda41e"
import script from "./ChatGroupReaded.vue?vue&type=script&lang=js"
export * from "./ChatGroupReaded.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupReaded.vue?vue&type=style&index=0&id=4fdda41e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports